import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const MediaUnavailableLockIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_26797_247018)">
        <mask
          id="mask0_26797_247018"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="1"
          y="-1"
          width="18"
          height="19"
        >
          <path d="M1.37805 -1H19V17.122H1.37805V-1Z" fill="white" />
        </mask>
        <g mask="url(#mask0_26797_247018)">
          <path
            d="M4.89008 8.04881C4.89008 7.40224 5.41423 6.87808 6.06081 6.87808C6.70739 6.87808 7.23154 7.40224 7.23154 8.04881C7.23154 8.69539 6.70739 9.21955 6.06081 9.21955C5.41423 9.21955 4.89008 8.69539 4.89008 8.04881Z"
            fill="currentColor"
          />
          <line
            x1="3.62641"
            y1="3.51221"
            x2="15.6527"
            y2="15.5385"
            stroke="currentColor"
            strokeWidth="1.31707"
            strokeLinecap="round"
          />
          <g clipPath="url(#clip1_26797_247018)">
            <path
              d="M16.0244 3.34145H15.6951V2.90243C15.6951 2.05515 15.0058 1.36584 14.1585 1.36584C13.3112 1.36584 12.622 2.05515 12.622 2.90243V3.34145H12.2927C12.232 3.34145 12.1829 3.39055 12.1829 3.45121V6.19512C12.1829 6.43725 12.3798 6.63414 12.622 6.63414H15.6951C15.9372 6.63414 16.1341 6.43724 16.1341 6.19511V3.45121C16.1341 3.39055 16.085 3.34145 16.0244 3.34145ZM14.4872 5.63422C14.4906 5.66519 14.4806 5.69628 14.4598 5.71954C14.439 5.7428 14.4092 5.75609 14.3781 5.75609H13.939C13.9078 5.75609 13.878 5.7428 13.8572 5.71954C13.8364 5.69629 13.8265 5.6652 13.8299 5.63422L13.8992 5.0116C13.7867 4.92981 13.7195 4.80044 13.7195 4.65853C13.7195 4.4164 13.9164 4.2195 14.1585 4.2195C14.4007 4.2195 14.5976 4.41639 14.5976 4.65853C14.5976 4.80044 14.5304 4.92981 14.4179 5.0116L14.4872 5.63422ZM15.0366 3.34145H13.2805V2.90243C13.2805 2.41828 13.6744 2.02438 14.1585 2.02438C14.6427 2.02438 15.0366 2.41828 15.0366 2.90243V3.34145Z"
              fill="#DC2626"
            />
          </g>
          <path
            d="M3.96387 4.47461C4.02794 4.62278 4.12015 4.76175 4.24121 4.88281L4.62695 5.26855H4.59766C3.70878 5.26875 2.9873 5.98999 2.9873 6.87891V12.5498L4.54395 10.9941C5.05829 10.4798 5.8919 10.4798 6.40625 10.9941L7.52441 12.1113L9.49609 10.1377L14.0928 14.7354C14.1228 14.7653 14.1545 14.7929 14.1865 14.8193C13.7322 15.417 13.0157 15.8056 12.207 15.8057H4.59766C3.22397 15.8055 2.10957 14.6911 2.10938 13.3174V6.87891C2.10938 5.72418 2.89718 4.75509 3.96387 4.47461ZM14.6943 11.6113L13.8164 10.7334V7.99512C13.8773 7.99787 13.9385 8 14 8C14.2369 8 14.4687 7.97797 14.6943 7.93848V11.6113ZM10.0195 4.39062C10.049 4.69466 10.1133 4.9883 10.207 5.26855H8.35156L7.47363 4.39062H10.0195Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_26797_247018">
          <rect width="18" height="18" fill="white" />
        </clipPath>
        <clipPath id="clip1_26797_247018">
          <rect
            width="5.26829"
            height="5.26829"
            fill="white"
            transform="translate(11.5244 1.36584)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MediaUnavailableLockIcon;
